import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { isAuthenticated, currentUser, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }

    if (allowedRoles && currentUser) {
        const hasRequiredRole = allowedRoles.includes(currentUser.userRolesId);

        if (!hasRequiredRole) {
            return <Navigate to="/acceso-denegado" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;